module.exports = __webpack_public_path__ + "static/media/funzoft.d1406f73.jpg";